export default (state, count) => {
    state.postTotalNumber = count
}
